export default __webpack_public_path__ + "static/media/banktransfer.e3552b0e.svg";